import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Tooltip,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  useMaterialReactTable,
  MaterialReactTable,
} from "material-react-table";
import Header from "../../component/Header";
import {
  fetchCategoriesAction,
  deleteCategoriesAction,
  updateRowOrderAction
} from "../../state/categories/categorySlice";

import AddCategoryForm from "./addCat";
import EditCategory from "./editCat";

const Categories = () => {
  const dispatch = useDispatch();

  const [dataSource, setDataSource] = useState([]);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [openToast, setOpenToast] = useState(false);

  const categories = useSelector((state) => state.categories.catDetails);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    dispatch(fetchCategoriesAction());
  }, [dispatch]);

  useEffect(() => {
    if (categories) {
      const data = categories.map((item) => ({ ...item, id: item.id }));
      setDataSource(data);
    }
  }, [categories]);

  const openHandler = () => {
    setOpenDrawer((o) => !o);
  };
  const openEditHandler = () => {
    setOpenEditDrawer((o) => !o);
  };

  const handleDeleteCategory = async () => {
    if (categoryToDelete) {
      await dispatch(deleteCategoriesAction(categoryToDelete));
      setDeleteConfirmationOpen(false);
      await dispatch(fetchCategoriesAction());
      setToastMessage("Category deleted successfully");
      setOpenToast(true);
    }
  };

  const handleConfirmDelete = (categoryId) => {
    setCategoryToDelete(categoryId);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    setCategoryToDelete(null);
    setDeleteConfirmationOpen(false);
  };

  const handleEditDetails = (id) => {
    openEditHandler();
    setEditId(id);
  };
  const handleRowOrderChange = (newData) => {
    // Dispatch the action to update the row order
    dispatch(updateRowOrderAction(newData))
      .then(() => {
        // If the action was successful, update the local state
        setDataSource(newData);
        console.log(newData);
        dispatch(fetchCategoriesAction());
      })
      .catch((error) => {
        console.error("Error updating row order:", error);
        // Handle the error if necessary
        // You might want to show a toast message or handle the error in some other way
      });
  };
  const columns = [
    {
      accessorKey: "orderNumber",
      header: "ID",
      size: 50,
    },
    {
      accessorKey: "name",
      header: "Name",
      size: 100,
    },
    {
      accessorKey: "main_image",
      header: "Image",
      size: 100,
      Cell: ({ row }) => (
        <img
          src={row.original.main_image}
          alt="main_image"
          style={{ width: "50px", height: "50px" }}
        />
      ),
    },

    {
      header: "Actions",
      size: 50,
      Cell: ({ row }) => (
        <span>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={() => handleConfirmDelete(row.original._id)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton
              color="error"
              onClick={() => handleEditDetails(row.original._id)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </span>
      ),
    },
  ];

  const handleToastClose = () => {
    setOpenToast(false);
  };

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: dataSource,
    enableRowOrdering: true,
    enableSorting: true,
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          const newData = [...dataSource];
          newData.splice(
            hoveredRow.index,
            0,
            newData.splice(draggingRow.index, 1)[0]
          );
          handleRowOrderChange(newData);
        }
      },
    }),
  });
  return (
    <>
      <AddCategoryForm handleClose={openHandler} open={openDrawer} />
      <EditCategory
        handleClose={openEditHandler}
        open={openEditDrawer}
        id={editId}
      />
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCloseDeleteConfirmation}
        aria-labelledby="delete-confirmation-dialog-title"
      >
        <DialogTitle id="delete-confirmation-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this category?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirmation} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteCategory} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={handleToastClose}
        message={toastMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        key={"bottom-left"}
      />

      <Box m="1rem 1.5rem">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Header title="Categories" subtitle="List of Categories" />
          <Button
            variant="contained"
            onClick={openHandler}
            color="secondary"
            size="lg"
            startIcon={<AddCircleOutlineIcon />}
          >
            Add
          </Button>
        </div>
        <Box mt="10px" height="75vh">
          <MaterialReactTable table={table} />
        </Box>
      </Box>
    </>
  );
};

export default Categories;
